(() => {
  if (customElements.get('mimsy-announcement-ticker')) return;
  class MimsyAnnouncementTicker extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.button = this.querySelector('[data-mimsy-ticker-toggle]');
      if (!this.button) return;
      this.paused = this.paused || false;
      this.sync = () => {
        const stationary = this.dataset.autoplay !== 'true';
        const focusedLink = this.contains(document.activeElement) && document.activeElement !== this.button;
        const paused = this.paused || focusedLink || document.hidden;
        this.dataset.state = stationary ? 'static' : paused ? 'paused' : 'running';
        this.button.hidden = false;
        this.button.disabled = stationary;
        this.button.setAttribute('aria-pressed', String(stationary || this.paused));
        this.button.textContent = stationary ? this.button.dataset.static : this.paused ? this.button.dataset.resume : this.button.dataset.pause;
      };
      const options = { signal: this.abort.signal };
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      document.addEventListener('visibilitychange', this.sync, options);
      this.addEventListener('focusin', this.sync, options);
      this.addEventListener('focusout', () => queueMicrotask(() => { if (this.isConnected) this.sync(); }), options);
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('mimsy-announcement-ticker', MimsyAnnouncementTicker);
})();
